import React, { useMemo, useState, useEffect, useRef } from 'react';
import {EuiFlexGroup,EuiFlexItem, EuiFormRow, EuiFieldText, EuiButton, EuiSpacer, EuiCallOut, EuiFormControlLayoutDelimited, EuiIcon, EuiText} from '@elastic/eui';
import {ComboDireccionesNegocioContainer as ComboDirecciones} from '../../../../components/Combos/DireccionesNegocio/container';
import {ComboSociedadesContainer as ComboSociedades} from '../../../../components/Combos/Sociedades/container';
import SelectorFecha from '../../../../../../shared/components/Combos/Fecha';
import { CreateFechaMoment, ToSQL } from '../../../../../../shared/utils/fecha';
import { PERFIL_ADMIN } from '../../../../../../shared/constanst/constants';
import moment from 'moment';
import { AdjuntosExpatriadosScreen } from '../../AdjuntosExpatriados';

import './styles.css';


export const Formulario = (props)=>{
  
  let {onSave, currentUser, selected, onClose, onOpenHistoricoAdjuntosExpatriado, translate} = props

  const formRefAdjuntos=useRef();
  
  let [dni,setDni] = useState(selected.dni)
  let [nombre, setNombre] = useState(selected.nombre)
  let [idDN, setIdDN] = useState(selected.idDN)
  let [fechaBaja, setFechaBaja] = useState((selected.fechaBaja!==null?CreateFechaMoment(selected.fechaBaja):null))
  let [fechaFacturacionExpatriadoInicial, setFechaFacturacionExpatriadoInicial] = useState((selected.fechaFacturacionExpatriadoInicial!==null?CreateFechaMoment(selected.fechaFacturacionExpatriadoInicial):null))
  let [fechaFacturacionExpatriadoFinal, setFechaFacturacionExpatriadoFinal] = useState((selected.fechaFacturacionExpatriadoFinal!==null?CreateFechaMoment(selected.fechaFacturacionExpatriadoFinal):null))
  let [fechaExpatriadoDesde, setFechaExpatriadoDesde] = useState((selected.fechaExpatriadoDesde!==null?CreateFechaMoment(selected.fechaExpatriadoDesde):null))
  let [fechaExpatriadoHasta, setFechaExpatriadoHasta] = useState((selected.fechaExpatriadoHasta!==null?CreateFechaMoment(selected.fechaExpatriadoHasta):null))
  let [empresaExpatriado,setEmpresaExpatriado] = useState(selected.empresaExpatriado)
  let [centroCostoDestinoExpatriado, setCentroCostoDestinoExpatriado] = useState(selected ? selected.centroCostoDestinoExpatriado : undefined)
  let [grupoFacturaExpatriado, setGrupoFacturaExpatriado] = useState((selected.grupoFacturaExpatriado!==null? selected.grupoFacturaExpatriado : undefined))
  let [referenciaFacturaExpatriado, setReferenciaFacturaExpatriado] = useState((selected.referenciaFacturaExpatriado!==null? selected.referenciaFacturaExpatriado : '-'))
  

  useEffect(()=>{if(fechaExpatriadoDesde===null){setFechaExpatriadoHasta(null)}},[fechaExpatriadoDesde])


  const getIdEmpleado = useMemo(() =>{return selected.idEmpleado},[selected])

  const getPermisoRol = useMemo(() =>{return selected.rol},[selected])

  const esExpatriado = useMemo(() => fechaExpatriadoDesde!==null && 
    ((moment(ToSQL(moment(fechaExpatriadoHasta),'-')).isSameOrAfter(ToSQL(moment(Date.now()),'-'))) || fechaExpatriadoHasta===null)
  ,[fechaExpatriadoDesde,fechaExpatriadoHasta])

  const getMinDateFacturacionInicial = useMemo(()=> { 
    return moment(fechaExpatriadoDesde)
  },[fechaExpatriadoDesde])

  const getMaxDateFacturacionInicial = useMemo(()=> { 
    return moment(fechaExpatriadoHasta)
  },[fechaExpatriadoHasta])

  const getMaxDateFacturacionFinal = useMemo(()=> { 
    return fechaExpatriadoHasta!==null ? moment(fechaExpatriadoHasta) : undefined;
  },[fechaExpatriadoHasta])

  const getMinDateFacturacionFinal = useMemo(()=> { 
    return fechaFacturacionExpatriadoInicial!==null ? moment(fechaFacturacionExpatriadoInicial) : undefined;
  },[fechaFacturacionExpatriadoInicial])

  const getData = () =>{
    return {
      dni: dni,
      expatriado: esExpatriado,
      idEmpleado: getIdEmpleado,
      fechaExpatriadoDesde: (fechaExpatriadoDesde!==null ? ToSQL(fechaExpatriadoDesde,'-') : fechaExpatriadoDesde),
      fechaExpatriadoHasta: (fechaExpatriadoHasta!==null ? ToSQL(fechaExpatriadoHasta,'-') : fechaExpatriadoHasta),
      empresaExpatriado: ((Array.isArray(empresaExpatriado)&&empresaExpatriado.length>0) ? empresaExpatriado[0].value : null),
      fechaFacturacionExpatriadoInicial: (fechaFacturacionExpatriadoInicial!==null ? ToSQL(fechaFacturacionExpatriadoInicial,'-') : fechaFacturacionExpatriadoInicial),
      fechaFacturacionExpatriadoFinal: (fechaFacturacionExpatriadoFinal!==null ? ToSQL(fechaFacturacionExpatriadoFinal,'-') : fechaFacturacionExpatriadoFinal),
      centroCostoDestinoExpatriado: centroCostoDestinoExpatriado===''?null:centroCostoDestinoExpatriado,
      grupoFacturaExpatriado: grupoFacturaExpatriado===''?null : grupoFacturaExpatriado,
      referenciaFacturaExpatriado: referenciaFacturaExpatriado==='-'?null : referenciaFacturaExpatriado
    }
  }

  const onSaveData = () =>{
    
      let newData = getData();
      let adjuntosExpatriado = formRefAdjuntos.current?.onSaveAdjuntosExpatriado();

      onSave && onSave(newData,adjuntosExpatriado)
  }

  const onChangeReferencia = (tipo,value)=>{
    if(tipo==='c')
    {
      setReferenciaFacturaExpatriado(`${value}-${getObraReferencia}`)
    }else{
      setReferenciaFacturaExpatriado(`${getCentroReferencia}-${value}`)
    }
  }

  const empresaExpatraidoError = useMemo(()=>(empresaExpatriado===undefined || empresaExpatriado===null || empresaExpatriado.length===0),[empresaExpatriado])


  const isInvalidEmpresaExpatriado = useMemo(()=> (fechaFacturacionExpatriadoInicial!==null && empresaExpatraidoError) ,[fechaFacturacionExpatriadoInicial,empresaExpatraidoError])
  const isInvalidReferencia = useMemo(()=>( referenciaFacturaExpatriado === undefined || (referenciaFacturaExpatriado.length>0 && referenciaFacturaExpatriado.length!==9)),[referenciaFacturaExpatriado])
  //const isInvalidFechaFacturacionExpatriadoInicial = useMemo(()=> (fechaFacturacionExpatriadoInicial===null && !empresaExpatraidoError) ,[fechaFacturacionExpatriadoInicial,empresaExpatraidoError])
  //const isInvalidGrupoFactura = useMemo(() => grupoFacturaExpatriado === undefined || grupoFacturaExpatriado === null || grupoFacturaExpatriado.trim() === "",[grupoFacturaExpatriado])


  const getCentroReferencia = useMemo(()=>{ if(referenciaFacturaExpatriado!==undefined){return referenciaFacturaExpatriado.split('-')[0]} },[referenciaFacturaExpatriado])
  const getObraReferencia = useMemo(()=>{ if(referenciaFacturaExpatriado!==undefined){return referenciaFacturaExpatriado.split('-')[1]} },[referenciaFacturaExpatriado])

  // Tiene que tener rellenado la sociedad y la fecha de inicio de facturación.
  const esExpatriadoFacturable = useMemo(()=> 
  //esExpatriado && 
  !empresaExpatraidoError && fechaFacturacionExpatriadoInicial!==null && 
  (fechaFacturacionExpatriadoFinal===null || ((moment(ToSQL(moment(fechaFacturacionExpatriadoFinal),'-')).isSameOrAfter(ToSQL(moment(Date.now()),'-'),'month'))))
  ,[esExpatriado,empresaExpatraidoError,fechaFacturacionExpatriadoInicial,fechaFacturacionExpatriadoFinal])

  // No es obligatoria la sociedad (aunque puede estar rellenada) y 
  // NO tiene fecha de inicio ni fin de facturación. No entraría en la factura por no ser facturable ni podría grabar partes por ser expatriado.
  const esExpatriadoNoFacturable = useMemo(()=>{
    return esExpatriado && ((fechaFacturacionExpatriadoInicial===null && fechaFacturacionExpatriadoFinal===null && !esExpatriadoFacturable)
    || (fechaFacturacionExpatriadoInicial!==null && empresaExpatraidoError))
  },[esExpatriado,fechaExpatriadoDesde,fechaFacturacionExpatriadoInicial,fechaFacturacionExpatriadoFinal,esExpatriadoFacturable, empresaExpatraidoError])


  const ExpatriadoState = useMemo(()=>{
    const stateTitle = !esExpatriado ? translate("no-expatriado") : (esExpatriadoFacturable ? translate("expatriado-facturable") : esExpatriadoNoFacturable ? translate("expatriado-sin-configurar") : "");
    const addonClass = !esExpatriado ? "default" : (esExpatriadoFacturable ? "correct" : esExpatriadoNoFacturable ? "warning" : "");

    let rolActual = '';

    switch (getPermisoRol) {
      case 'AD': rolActual = 'Administrador' 
      break;
      case 'ADL': rolActual = 'Administrador Local' 
      break;
      case 'CON': rolActual = 'Consulta' 
      break;
      default: rolActual = 'Administrador Global'
      break;
    }

    return(
      <EuiFlexItem className={`infoExpatriadoState ${addonClass}`} style={{padding:'5px'}}>
        <EuiFlexGroup justifyContent='spaceEvenly'>
          <EuiFlexItem><h2>{stateTitle}</h2></EuiFlexItem>
          <EuiFlexItem className='infoRolActual'><h2>{`Estás como ${rolActual}`}</h2></EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexItem>
    )
    // return (<EuiFlexItem grow={false} className={`infoExpatriadoState ${addonClass}`}>
    //   <h3>{stateTitle}</h3></EuiFlexItem>)

  },[esExpatriado,esExpatriadoFacturable,esExpatriadoNoFacturable,getPermisoRol])

  const isDisabledAdjuntos = useMemo(()=>(getIdEmpleado===undefined || getIdEmpleado===null || fechaExpatriadoDesde===null),[getIdEmpleado,fechaExpatriadoDesde])


  /*DATOS USUARIOS*/
  const getusuariosPanel = ()=>(
    <EuiFlexGroup direction='column'>
      <EuiFlexItem>
        <EuiFlexGroup>
            <EuiFlexItem>
              <EuiFormRow fullWidth label={translate("dni")}>
                <EuiFieldText fullWidth value={dni} name="txtDni" readOnly={true}/>
              </EuiFormRow>
            </EuiFlexItem>

            <EuiFlexItem>
              <EuiFormRow fullWidth label={translate("nombre")}>
                <EuiFieldText fullWidth value={nombre} name="txtNombre" readOnly={true}/>
              </EuiFormRow>
            </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexItem>

      <EuiFlexItem>
        <EuiFlexGroup>
          <EuiFlexItem>
            <EuiFormRow fullWidth label={translate("fecha-de-baja")}>
              <SelectorFecha fullWidth selected={fechaBaja} popoverPlacement="left" readOnly={true}/>
            </EuiFormRow>
          </EuiFlexItem>

          <EuiFlexItem>
            <EuiFormRow fullWidth label={translate('direccion-de-negocio')}>
              <ComboDirecciones fullWidth selectedOptions={idDN} isDisabled={true} onChange={value => {setIdDN(value); }}/>
            </EuiFormRow>
          </EuiFlexItem>
          </EuiFlexGroup>
      </EuiFlexItem>

    </EuiFlexGroup>
  )

  /* DATOS EXPATRIACION */
  const getExpatriadosPanel = ()=>(
    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiFlexGroup>
          <EuiFlexItem>
            <EuiFormRow label={translate('empresa-sociedad-expatriado')} fullWidth isInvalid={isInvalidEmpresaExpatriado}>
              <ComboSociedades fullWidth admExpatriados={true} selectedOptions={empresaExpatriado} onChange={value =>{setEmpresaExpatriado(value)}} 
              isInvalid={isInvalidEmpresaExpatriado} isDisabled={fechaExpatriadoDesde===null || getPermisoRol === 'CON'} rol={getPermisoRol}/>
            </EuiFormRow>
          </EuiFlexItem>
        </EuiFlexGroup>
                        <EuiSpacer size='m'/>
        <EuiFlexGroup>
          <EuiFlexItem>
              <EuiFormRow fullWidth label={translate('expatriado-desde')}>
                <SelectorFecha fullWidth disabled={true} popoverPlacement="top" selected={fechaExpatriadoDesde}  onChange={date => setFechaExpatriadoDesde(date)} onClear={() => setFechaExpatriadoDesde(null)}/>
              </EuiFormRow>
          </EuiFlexItem>
          <EuiFlexItem>
              <EuiFormRow fullWidth label={translate('expatriado-hasta')}>
                <SelectorFecha fullWidth disabled={true} popoverPlacement="top" selected={fechaExpatriadoHasta} onChange={date => setFechaExpatriadoHasta(date)} onClear={() => setFechaExpatriadoHasta(null)}/>
              </EuiFormRow>
          </EuiFlexItem>
        </EuiFlexGroup>

                        <EuiSpacer size='m'/>

        <EuiFlexGroup>
          <EuiFlexItem>
              <EuiFormRow fullWidth label={`${translate('facturacion-inicial')} (${translate('alta-nomina-local')})`} >
                <SelectorFecha fullWidth popoverPlacement="top" selected={fechaFacturacionExpatriadoInicial} minDate={getMinDateFacturacionInicial} maxDate={getMaxDateFacturacionInicial}  onChange={date => setFechaFacturacionExpatriadoInicial(date)} 
                onClear={() => setFechaFacturacionExpatriadoInicial(null)} disabled={fechaExpatriadoDesde===null || getPermisoRol === 'CON'}/>
              </EuiFormRow>
          </EuiFlexItem>
          <EuiFlexItem>
              <EuiFormRow fullWidth label={`${translate('facturacion-final')} (${translate('baja-nomina-local')})`}>
                <SelectorFecha fullWidth popoverPlacement="top" selected={fechaFacturacionExpatriadoFinal} minDate={getMinDateFacturacionFinal} maxDate={getMaxDateFacturacionFinal} 
                onChange={date => setFechaFacturacionExpatriadoFinal(date)} onClear={() => setFechaFacturacionExpatriadoFinal(null)} disabled={fechaExpatriadoDesde===null || getPermisoRol === 'CON'}/>
              </EuiFormRow>
          </EuiFlexItem>
        </EuiFlexGroup>
                        <EuiSpacer size='m'/>

        <EuiFlexGroup>
          <EuiFlexItem grow={false}>
            <EuiFormRow fullWidth label={translate('centro-costo-destino')}>
              <EuiFieldText fullWidth value={centroCostoDestinoExpatriado} name="txtCentroCostoDestinoExpatriado" onChange={e => setCentroCostoDestinoExpatriado(e.target.value)} 
              readOnly={fechaExpatriadoDesde===null || getPermisoRol === 'CON'} type="text"/>
                {/* pattern="[0-9]*" */}
            </EuiFormRow>
          </EuiFlexItem>
          <EuiFlexItem>
            <EuiFormRow fullWidth label={translate('grupoFactura')}>
              <EuiFieldText fullWidth 
              // prepend={isInvalidGrupoFactura ? null : getDNSelection}
              value={grupoFacturaExpatriado} name="txtGrupoFacturaExpatriado" onChange={e => setGrupoFacturaExpatriado(e.target.value)} 
              readOnly={fechaExpatriadoDesde===null || getPermisoRol === 'CON'} type="text"/>
            </EuiFormRow>
          </EuiFlexItem>

          <EuiFlexItem>
            <EuiFormRow fullWidth label={translate('centro-costo-origen-factura')}>
              <EuiFormControlLayoutDelimited
              fullWidth
              isInvalid={isInvalidReferencia}
              startControl={
                <EuiFieldText value={getCentroReferencia} name="txtCentroReferencia" placeholder='Centro' compressed
                onChange={e => onChangeReferencia('c',e.target.value)} isInvalid={isInvalidReferencia} 
                readOnly={fechaExpatriadoDesde===null || getPermisoRol === 'CON'} type="text" maxLength={3}/>
              }
              delimiter={<EuiText>{`-`}</EuiText>}
              endControl={
                <EuiFieldText value={getObraReferencia} name="txtObraReferencia" placeholder='Obra' compressed
                onChange={e => onChangeReferencia('o',e.target.value)} isInvalid={isInvalidReferencia} 
                readOnly={fechaExpatriadoDesde===null || getPermisoRol === 'CON'} type="text" maxLength={5}/>
              }
            />
              {/* <EuiFieldText fullWidth 
              value={referenciaFacturaExpatriado} name="txtReferenciaFacturaExpatriado" onChange={e => setReferenciaFacturaExpatriado(e.target.value)} 
              readOnly={fechaExpatriadoDesde===null || getPermisoRol === 'CON'} type="text"/> */}
            </EuiFormRow>
          </EuiFlexItem>

        </EuiFlexGroup>

        <EuiSpacer size='m'/>
          <AdjuntosExpatriadosScreen disabled={isDisabledAdjuntos} compressed={true} multiple={true} ref={formRefAdjuntos} 
          idEmpleado={getIdEmpleado} isEdit={selected!==undefined} onOpenHistoricoAdjuntosExpatriado={onOpenHistoricoAdjuntosExpatriado}/>
      </EuiFlexItem>
    </EuiFlexGroup>
  )

  return (
    <EuiFlexGroup direction='column'>
      <EuiFlexItem>{getusuariosPanel()}</EuiFlexItem>
      <EuiFlexItem>{ExpatriadoState}</EuiFlexItem>
      <EuiFlexItem>{getExpatriadosPanel()}</EuiFlexItem>
      <EuiSpacer size="l" />
      <EuiFlexGroup style={{position:'sticky', bottom:0, backgroundColor:'white'}}>
        <EuiFlexItem>
          <EuiButton onClick={onSaveData}>
            {translate('guardar')}
          </EuiButton>
        </EuiFlexItem>
        <EuiFlexItem>
          <EuiButton color="danger" onClick={()=>onClose()}>{translate('cancelar')}</EuiButton>
        </EuiFlexItem>
      </EuiFlexGroup>
    </EuiFlexGroup>
  )
}
export default Formulario;